import React from 'react';
import { Input, FormLabel, FormControl } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const ChablaInput = ({ children, title, ...rest }) => {
  return (
    <FormControl id={title}>
      {title && <FormLabel>{title}</FormLabel>}
      <Input borderRadius={0} {...rest}>
        {children}
      </Input>
    </FormControl>
  );
};

ChablaInput.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
};

ChablaInput.defaultProps = {};

export default ChablaInput;
